/** Klockan går att byta ut, så att proven kan köra dygn på sekunder. */
export interface Klocka {
  nu(): number;
}

export const systemklocka: Klocka = { nu: () => Date.now() };

/** En klocka som bara går när provet flyttar den. */
export class Provklocka implements Klocka {
  t: number;

  constructor(start = Date.UTC(2026, 9, 17, 8, 0, 0)) {
    this.t = start;
  }

  nu(): number {
    return this.t;
  }

  framat(ms: number): number {
    this.t += ms;
    return this.t;
  }
}

export const SEKUND = 1000;
export const MINUT = 60 * SEKUND;
export const TIMME = 60 * MINUT;
export const DYGN = 24 * TIMME;
